/**
 * Offsets for the app-root `<Toaster>` (main.tsx).
 *
 * Each keeps the shared component's default gap from the viewport edge (24px
 * on wide screens, 16px below 600px where the stack goes full-width) and
 * adds `--wagepro-toast-clearance-bottom`, which wagepro-theme.css sets to
 * the ESS bottom tab bar's height while that bar is on screen and to 0
 * everywhere else. So a toast never covers the employee navigation, and a
 * tap on a tab can never land on the toast and pause its auto-dismiss.
 *
 * Only `bottom` is set: the object form keeps the defaults for the other
 * sides.
 */
import type { ToasterOffset } from '@jumpstone/ui-react';

export const WAGEPRO_TOASTER_OFFSET: ToasterOffset = {
  bottom: 'calc(24px + var(--wagepro-toast-clearance-bottom, 0px))',
};

export const WAGEPRO_TOASTER_MOBILE_OFFSET: ToasterOffset = {
  bottom: 'calc(16px + var(--wagepro-toast-clearance-bottom, 0px))',
};
